export default store => {
  return {
    path: "organizationApproval",
    getComponent(nextState, cb) {
      // require.ensure([],require => {
      const comp = require("./OrganizationApproval").default;
      cb(null, comp);
      // },"administrator-tooling");
    },
  };
};
